// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pages-TriggerJob-styles___container--lNwdo {
  max-width: 900px;
  padding: 40px;
}

.pages-TriggerJob-styles___title--x0y3f {
  margin: 0 0 24px;
  font-size: 24px;
  font-weight: 700;
}

.pages-TriggerJob-styles___description--sdbTl {
  margin-bottom: 8px;
}

.pages-TriggerJob-styles___jobBody--_pCXG .MuiInputBase-root {
    height: auto;
  }

.pages-TriggerJob-styles___actions--vmQZU {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./pages/TriggerJob/styles.pcss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAGE;IACE,YAAY;EACd;;AAGF;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB","sourcesContent":[".container {\n  max-width: 900px;\n  padding: 40px;\n}\n\n.title {\n  margin: 0 0 24px;\n  font-size: 24px;\n  font-weight: 700;\n}\n\n.description {\n  margin-bottom: 8px;\n}\n\n.jobBody {\n  :global(.MuiInputBase-root) {\n    height: auto;\n  }\n}\n\n.actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `pages-TriggerJob-styles___container--lNwdo`,
	"title": `pages-TriggerJob-styles___title--x0y3f`,
	"description": `pages-TriggerJob-styles___description--sdbTl`,
	"jobBody": `pages-TriggerJob-styles___jobBody--_pCXG`,
	"actions": `pages-TriggerJob-styles___actions--vmQZU`
};
module.exports = ___CSS_LOADER_EXPORT___;
